
import { useState } from 'react';
import { Load, LoadSchedule } from '../types';
import { useToast } from '@/hooks/use-toast';

export const useScheduleManagement = (loads: Load[], setLoads: React.Dispatch<React.SetStateAction<Load[]>>) => {
  const [isSchedulingOpen, setIsSchedulingOpen] = useState(false);
  const [selectedLoad, setSelectedLoad] = useState<Load | null>(null);
  const { toast } = useToast();

  const openScheduling = (load: Load) => {
    setSelectedLoad(load);
    setIsSchedulingOpen(true);
  };

  const closeScheduling = () => {
    setIsSchedulingOpen(false);
  };

  const handleSaveSchedule = (loadId: string, schedules: LoadSchedule[]) => {
    setLoads(prevLoads => 
      prevLoads.map(load => 
        load.id === loadId 
          ? { ...load, schedules } 
          : load
      )
    );
    
    setIsSchedulingOpen(false);
    
    toast({
      title: "Schedule updated",
      description: "The load schedule has been updated successfully.",
    });
  };

  return {
    isSchedulingOpen,
    selectedLoad,
    openScheduling,
    closeScheduling,
    handleSaveSchedule,
  };
};
